import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22RosterSection.tsx%22,%22import%22:%22Archivo%22,%22arguments%22:[{%22subsets%22:[%22latin%22],%22weight%22:%22500%22}],%22variableName%22:%22archivoSemiBold%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Archivo', 'Archivo Fallback'",
        fontWeight: 500,
fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
